import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectDistributionDefaults, updateDefaults } from '../../../../redux/panelDetailSlice';

export default function DistributionSection() {
  const dispatch = useDispatch();
  const dist = useSelector(selectDistributionDefaults);

  const handleChange = (field, value) => {
    dispatch(updateDefaults({
      section: 'distributionCompartment',
      changes: { [field]: typeof value === 'string' && !isNaN(parseFloat(value)) ? parseFloat(value) : value },
    }));
  };

  return (
    <div className="detail-section-content">
      <div className="detail-field">
        <label>Dagitim Genisligi (cm)</label>
        <input
          type="number"
          step="5"
          min="20"
          value={dist.width}
          onChange={e => handleChange('width', e.target.value)}
        />
      </div>

      <div className="detail-field">
        <label>Dagitim Yuksekligi</label>
        <div className="detail-radio-row">
          <label>
            <input
              type="radio"
              checked={dist.heightMode === 'METER_ONLY'}
              onChange={() => handleChange('heightMode', 'METER_ONLY')}
            />
            Sayac bolmesi yuksekliginde
          </label>
          <label>
            <input
              type="radio"
              checked={dist.heightMode === 'METER_PLUS_BUSBAR'}
              onChange={() => handleChange('heightMode', 'METER_PLUS_BUSBAR')}
            />
            Sayac + Bara yuksekliginde
          </label>
        </div>
      </div>
    </div>
  );
}
